import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a404d7a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-joinus-form"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提交后，我们会在收到您垂询3个工作日内与您联系", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_form = _resolveComponent("t-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_t_toast = _resolveComponent("t-toast");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_form, {
    ref: "formRef",
    model: _ctx.formData,
    "item-config": _ctx.formConfig,
    gutter: 32,
    "hide-label": true,
    "is-label-fill-placeholder": true,
    "label-position": "top"
  }, null, 8, ["model", "item-config"]), _createVNode(_component_el_button, {
    class: "submit-btn",
    size: "large",
    type: "primary",
    onClick: _ctx.handleSubmit
  }, {
    default: _withCtx(() => [_createTextVNode(" 预约一对一咨询 ")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_t_toast, {
    class: "t-toast",
    "is-show": _ctx.isShowToast
  }, null, 8, ["is-show"]), _hoisted_2]);
}